export default {
  emptyBtn: false,
  submitBtn: false,
  editBtn: false,

  column: [
    {
      label: 'id',
      display: false,
      prop: 'id',
      span: 8,
    },
    {
      label: '车场名称',
      disabled: true,
      span: 8,
      prop: 'spaceName',
      rules: [
        {
          required: true,
        },
      ],
    },
    {
      label: '车牌号',
      disabled: true,
      span: 8,
      prop: 'carNo',
    },
    {
      label: '区域名称',
      prop: 'regions',
      hide: true,
      type: 'tree',
      disabled: true,
      multiple: true,
      checkStrictly: true,
      dataType: 'string',
      span: 8,
      dicData: [],
      props: {
        label: 'title',
        value: 'id',
      },
      rules: [
        {
          required: false,
          message: '请选择通行区域',
          trigger: 'change',
        },
      ],
    },
    // {
    //   label: '车辆分类',
    //   prop: 'carClass',
    //   disabled: true,
    //   span: 8,
    //   type: 'tree',
    //   dicData: [],
    //   props: {
    //     label: 'dictValue',
    //     value: 'dictKey',
    //   },
    //   rules: [
    //     {
    //       required: true,
    //       message: '请选择车辆分类',
    //       trigger: 'blur',
    //     },
    //   ],
    // },
    {
      label: '车辆类别',
      prop: 'carCategory',
      disabled: true,
      span: 8,
      type: 'tree',
      dicData: [],
      props: {
        label: 'dictValue',
        value: 'dictKey',
      },
      rules: [
        {
          required: false,
          message: '请选择车辆类别',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '车辆类型',
      prop: 'carType',
      disabled: true,
      type: 'tree',
      span: 8,
      dicData: [],
      props: {
        label: 'dictValue',
        value: 'dictKey',
      },
      rules: [
        {
          required: false,
          message: '请选择车辆类型',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '收费套餐',
      disabled: true,
      span: 8,
      prop: 'ruleName',
      rules: [
        {
          required: true,
        },
      ],
    },
    {
      label: '租赁起期',
      prop: 'buyStartTime',
      type: 'date',
      format: 'yyyy-MM-dd',
      valueFormat: 'yyyy-MM-dd 00:00:00',
      span: 8,
      disabled: true,
      rules: [
        {
          required: false,
          message: '请选择租赁启期',
          trigger: 'change',
        },
      ],
    },
    // {
    //   label: '租赁时长',
    //   prop: 'cycleNum',
    //   disabled: true,
    //   type: 'tree',
    //   dicData: [],
    //   span: 8,
    //   props: {
    //     label: 'dictValue',
    //     value: 'dictKey',
    //   },
    //   rules: [
    //     {
    //       required: false,
    //       message: '请选择租赁时长',
    //       trigger: 'blur',
    //     },
    //   ],
    // },
    {
      label: '租赁止期',
      prop: 'buyEndTime',
      type: 'date',
      format: 'yyyy-MM-dd',
      valueFormat: 'yyyy-MM-dd 23:59:59',
      span: 8,
      disabled: true,
    },
    {
      label: '优惠规则',
      disabled: true,
      span: 8,
      prop: 'discountName',
    },
    {
      label: '客户姓名',
      search: true,
      prop: 'customerName',
      disabled: true,
      span: 8,
      rules: [
        {
          required: false,
          message: '请输入车主名称',
          trigger: 'change',
        },
      ],
    },
    {
      label: '客户手机',
      prop: 'customerPhone',
      search: true,
      span: 8,
      disabled: true,
      rules: [
        { pattern: /^[0-9]*[0-9][0-9]*$/, message: '手机号格式错误' },
        {
          trigger: 'blur',
          min: 11,
          max: 11,
          message: '请输入11位手机号',
        },
      ],
    },
    {
      label: '房产信息',
      prop: 'areaName',
      type: 'input',
      span: 8,
      disabled: true,
      readonly: true,
      // formslot: true,
    },
    {
      label: '车位编号',
      prop: 'lotNo',
      disabled: true,
      span: 8,
      rules: [
        {
          required: false,
          message: '请输入车位编号',
          trigger: 'change',
        },
      ],
    },
    {
      label: '备注',
      prop: 'remark',
      hide: true,
      span: 24,
      type: 'textarea',
      minRows: 4,
      maxlength: 200,
      showWordLimit: true,
      overHidden: true,
      disabled: true,
      rules: [
        {
          required: false,
          message: '请输入备注',
          trigger: 'change',
        },
      ],
    },
    {
      label: '操作',
      prop: 'operateType',
      display: false,
    },
    {
      label: '收款单号',
      prop: 'payId',
      hide: true,
      display: false,
      rules: [
        {
          required: true,
          message: '请输入收款单主键',
          trigger: 'change',
        },
      ],
    },
    {
      label: '退款单号',
      display: false,
      hide: true,
      prop: 'returnId',
      rules: [
        {
          required: true,
          message: '请输入退款单主键',
          trigger: 'change',
        },
      ],
    },
    {
      label: '退费标识',
      prop: 'returnFlag',
      display: false,
      hide: true,
      rules: [
        {
          required: true,
          message: '请输入退费标识 0.未退费 1.已退费',
          trigger: 'change',
        },
      ],
    },
    {
      label: '退费金额',
      prop: 'returnMoney',
      display: false,
      hide: true,
      rules: [
        {
          required: true,
          message: '请输入退费金额',
          trigger: 'change',
        },
      ],
    },
    {
      label: '小区名称',
      prop: 'communityName',
      type: 'input',
      display:false,
      disabled: true,
    },
    {
      label: '楼栋',
      prop: 'buildingId',
      type: 'input',
      display:false,
      disabled: false,
      formslot: true,
    },
    {
      addDisplay: false,
      editDisplay: false,
      label: '操作日志',
      disabled: true,
      prop: 'info',
      span: 24,
      hide: true,
      formslot: true,
    }
  ],
};
